export const TEMPORARY_TEMPLATE_WARNING = 'This temporary template was created based on ';